<div class="mat-dark">
  <p>{{ 'doyouWannaCont' | t }}</p>
  <a href="{{ this.__url }}">
    <button mat-stroked-button>{{ 'yes' | t }}</button>
  </a>
  <button mat-stroked-button (click)="closeD()">{{ 'no' | t }}</button>
</div>
